import React from 'react';
import {observer} from 'mobx-react-lite';
import {Step1} from './Step1';
import {CurrentPageStore} from '@/store/content-optimizer/currentPage';

interface WelcomeProps {
  store: CurrentPageStore;
}

const Welcome: React.FC<WelcomeProps> = observer<WelcomeProps>(({store}) => {
  const {currentStep} = store;
  return (
    <>
      {currentStep === 1 && <Step1 store={store} />}
    </>
  );
});

export {Welcome};
